export const SELECTOR_GROUP_TYPE = {
  SYSTEM: "system",
  UNIT: "unit",
  INTERCONN: "interconn",
  LOAD: "load"
};

export const SELECTOR_GROUPS = [
  SELECTOR_GROUP_TYPE.UNIT,
  SELECTOR_GROUP_TYPE.SYSTEM,
  SELECTOR_GROUP_TYPE.INTERCONN,
  SELECTOR_GROUP_TYPE.LOAD
];

export const SELECTOR_TYPE = {
  SYSTEM_VARIABLES: "system_variables",
  SYSTEM_OBJECTS: "system_objects",
  UNIT_VARIABLES: "unit_variables",
  UNIT_OBJECTS: "unit_objects",
  INTERCONN_VARIABLES: "interconn_variables",
  INTERCONN_OBJECTS: "interconn_objects",
  LOAD_VARIABLES: "load_variables",
  LOAD_OBJECTS: "load_objects"
};

export const SELECTION_MODE = {
  SINGLE: "single",
  MULTIPLE: "multiple"
};

export const ROW_TYPE = {
  OBJECT: "object",
  VARIABLE: "variable",
  LABEL: "label"
};

export const PAGES = {
  FINANCIAL: "financial",
  PHYSICAL: "physical"
};

export const REPORT_ACTIONS = {
  SELECT: "select",
  DUPLICATE: "duplicate",
  ADD: "add",
  MOVE_UP: "move_up",
  MOVE_DOWN: "move_down",
  RUN_REPORT: "run_report",
  SAVE: "save",
  FULL_SCREEN: "full_screen",
  SMALL_SCREEN: "small_screen",
  CLOSE: "close",
  OPEN_REPORT_PROPS: "open_report_props",
  DOWNLOAD_CSV: "download_csv"
};

export const MENU_REPORT_ACTIONS = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete"
};

export const REPORT_STATUS = {
  INIT: "init",
  LOADING: "loading",
  ERROR: "error",
  MISSING_DATA: "missing_data",
  HAS_DATA: "has_data"
};
export const REQUEST_STATUS = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS"
};



// WEBPACK FOOTER //
// ./src/views/core/_utils/constants.js